import React from "react";
import { useSelector } from "react-redux";
import { FormControl, MenuItem, Select } from "@mui/material";

const SelectFieldCurriculum = ({ value = '', onChange }) => {
  const curriculumList = useSelector((state) => state?.assessment?.curriculum);
  if (curriculumList?.length < 2) {
    return <></>
  }
  return (
    <FormControl variant="outlined" className="max-w-120px min-w-120px">
      <Select
        variant="outlined"
        value={value}
        onChange={onChange}
        size="small"
      >
        {curriculumList?.map((cur) => (
          <MenuItem key={`curriculum-${cur._id}`} value={cur._id}>
            {cur.shortName} Curriculum
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default SelectFieldCurriculum;
